import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Plus } from "lucide-react";
import { ToolForm } from "./ToolForm";
import { Tool, ToolFormValues } from "@/types";

interface ToolHeaderProps {
  onToolSubmit: (values: ToolFormValues) => Promise<void>;
  isDialogOpen: boolean;
  setIsDialogOpen: (open: boolean) => void;
  editingTool: Tool | null;
  setEditingTool: (tool: Tool | null) => void;
}

export const ToolHeader = ({
  onToolSubmit,
  isDialogOpen,
  setIsDialogOpen,
  editingTool,
  setEditingTool
}: ToolHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-2xl font-bold">إدارة الأدوات</h2>
      <Dialog 
        open={isDialogOpen}
        onOpenChange={(open) => {
          if (!open) {
            setEditingTool(null);
          }
          setIsDialogOpen(open);
        }}
      >
        <DialogTrigger asChild>
          <Button 
            className="bg-primary hover:bg-primary/90 text-white font-medium px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2"
          >
            <Plus className="w-5 h-5" />
            إضافة أداة جديدة
          </Button>
        </DialogTrigger>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-primary">
              {editingTool ? 'تعديل الأداة' : 'إضافة أداة جديدة'}
            </DialogTitle>
          </DialogHeader>
          <ToolForm 
            onSubmit={onToolSubmit}
            initialData={editingTool || undefined}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};